import React, { MutableRefObject, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

import { Placement, SnippetTypes } from '@components/utils/prop-types'
import useClickAnyWhere from '@lib/hooks/useClickAnyWhere'
import usePortal from '@lib/hooks/usePortal'
import useResize from '@lib/hooks/useResize'
import clsx from 'clsx'
import TooltipIcon from './TooltipIcon'
import { getRect } from './helpers'
import { TooltipPosition, defaultTooltipPosition, getPosition } from './placement'


interface Props {
    parent?: MutableRefObject<HTMLElement | null> | undefined
    placement: Placement
    type: SnippetTypes
    visible: boolean
    hideArrow: boolean
    offset: number
    className?: string
    iconOffset: TooltipIconOffset
}
export type TooltipIconOffset = {
    x: string
    y: string
}

const TooltipContent: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    parent,
    visible,
    offset,
    iconOffset,
    placement,
    type,
    className,
    hideArrow,
}) => {


    const el = usePortal('tooltip')
    const selfRef = useRef<HTMLDivElement>(null)
    const [rect, setRect] = useState<TooltipPosition>(defaultTooltipPosition)

    const hasShadow = type === 'default'
    const classes = clsx('tooltip-content', className)
    if (!parent) return null
    /* eslint-disable */
    const updateRect = () => {
        const position = getPosition(placement, getRect(parent), offset, selfRef)
        setRect(position)
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useResize(updateRect)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useClickAnyWhere(() => updateRect())
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        updateRect()
    }, [visible])

    const preventHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
        event.nativeEvent.stopImmediatePropagation()
    }

    if (!el) return null
    return visible && createPortal(
        // <CssTransition visible={visible}>
        <div>
            <div className={classes} ref={selfRef} onClick={preventHandler}>
                <div className="inner">
                    {!hideArrow && <TooltipIcon placement={placement} shadow={hasShadow} />}
                    {children}
                </div>
                <style jsx>{`
          .tooltip-content {
            --tooltip-icon-offset-x: ${iconOffset.x};
            --tooltip-icon-offset-y: ${iconOffset.y};
            --tooltip-content-bg: rgba(255, 255, 255, 1);
            box-sizing: border-box;
            position: absolute;
            top: ${rect.top};
            left: ${rect.left};
            transform: ${rect.transform};
            background-color: var(--tooltip-content-bg);
            overflow: hidden;
            border-radius: 3px;
            padding: 0;
            z-index: 1000;
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);
            width: auto;
            height: auto;
          }

          .inner {
            box-sizing: border-box;
            position: relative;
     
            height: 100%;
          }
        `}</style>
            </div>
        </div>,
        // </CssTransition>,
        el,
    )
}

export default TooltipContent

